import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ThemeProvider } from './contexts/ThemeProvider'
import { initSentry } from './sentry'

// Initialize Sentry
initSentry();

// Enable Sentry test utilities in development
if (import.meta.env.DEV) {
  import('./utils/sentry-test');
}

// Create a client
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: true,
      staleTime: 0, // デフォルトは即座にstale
    },
  },
})

createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <ThemeProvider defaultTheme="system" storageKey="knitido-theme">
      <App />
    </ThemeProvider>
  </QueryClientProvider>
);
